import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};

export const API_CREATE_CATAGORY = async (data) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.post(
      "/category/create-category",
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
export const API_SEND_MESSAGE = async (data) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.post(
      "/chat/send-message",
      data,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_LIST_CONVERSATION = async ({ type, role, name,page,limit }) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.get(
      `/chat/conversation/conversations`,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
        params: { type, role, name,page,limit }, // Include dynamic params
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
export const CONVERSATION_LISTING = async ({ id }) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.get(
      `/chat/conversation/messages/${id}`,
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
export const CONVERSATION_SEEN = async (id) => {
  try {
    const authToken = getAuthToken(); // Get token each time before making an API request

    const response = await PrivateAxiosInstance.post(
      `/chat/conversation/seen-at/${id}`,
      {},
      {
        headers: {
          Authorization: `${authToken}`, // Add the Authorization header with the token
        },
      }
    );
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
